import { render, staticRenderFns } from "./fileCategoryDrawer.vue?vue&type=template&id=0da5eaea&scoped=true&"
import script from "./fileCategoryDrawer.vue?vue&type=script&lang=js&"
export * from "./fileCategoryDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da5eaea",
  null
  
)

export default component.exports